import React from "react";
import "./privacy_policy.scss";
import Privacycontent from "../privacycontent/privacycontent";
const Privacy_policy = () => {
  return (
    <div className="container_">
      <div className="privacymain">
        <div className="privacytop">
          <h2>Privacy Policy</h2>
          <p>
            Please read our terms below to learn more about your rights and
            responsibilities as a AutoRed user.
          </p>
        </div>
        <Privacycontent />
      </div>
    </div>
  );
};

export default Privacy_policy;
